/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

/* eslint-disable no-console */

import classnames from 'classnames';
import React, { useEffect, useState } from 'react';

import Wait from '@react/react-spectrum/Wait';
import styles from './styles/iframe.styl';

const ViewPluginBridgedIframe = ({
  className,
  namespace,
  onLoadPlugin,
  onUnloadPlugin,
  title,
  visible
}) => {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    onLoadPlugin(namespace);
    return () => onUnloadPlugin(namespace);
  }, []);

  return (
    <div
      className={classnames(className, styles.root)}
      style={{ visibility: visible ? 'visible' : 'hidden' }}
    >
      <React.Fragment>
        <iframe
          className="viewPluginIframe"
          data-test-id={namespace}
          id={namespace}
          onLoad={() => setLoaded(true)}
          title={title}
          sandbox="allow-downloads allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
        />
        {!loaded && (
          <Wait
            style={{ visibility: visible ? 'visible' : 'hidden' }}
            className={styles.loading}
            size="L"
          />
        )}
      </React.Fragment>
    </div>
  );
};

ViewPluginBridgedIframe.displayName = 'ViewPluginBridgedIframe';
export default ViewPluginBridgedIframe;
